import React from 'react';

function Sealion7() {
  return <div>Sealion7</div>;
}

export default Sealion7;
